import { ToastProvider } from "@aurem/ui";
import { DevToolbar } from "components/DevToolbar";
import { InactivityDialog } from "components/InactivityDialog";
import { DecimalConfigProvider } from "pages/Controls/hooks/use-decimal-config";
import { ChatwootProvider } from "providers/ChatwootProvider";
import { I18nProvider } from "providers/I18nProvider";
import { PreferredLanguageProvider } from "providers/PreferredLanguageProvider";
import { CurrencyProvider } from "./providers/CurrencyProvider";
import { CustomAttributesProvider } from "./providers/CustomAttributesProvider";
import { DeploymentCountryProvider } from "./providers/DeploymentCountryProvider";
import { AppErrorBoundary } from "./root/AppErrorBoundary";
import AppRoutes from "./root/AppRoutes";

export const App = () => {
  return (
    <PreferredLanguageProvider>
      <I18nProvider>
        <ChatwootProvider>
          <CurrencyProvider>
            <DecimalConfigProvider>
              <DeploymentCountryProvider>
                <CustomAttributesProvider>
                  <AppErrorBoundary>
                    <AppRoutes />
                    <DevToolbar />
                    <ToastProvider />
                    <InactivityDialog />
                  </AppErrorBoundary>
                </CustomAttributesProvider>
              </DeploymentCountryProvider>
            </DecimalConfigProvider>
          </CurrencyProvider>
        </ChatwootProvider>
      </I18nProvider>
    </PreferredLanguageProvider>
  );
};
